import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFilteredInspectionJobsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Inspection_Jobs_Bool_Exp>;
}>;


export type GetFilteredInspectionJobsQuery = { __typename?: 'query_root', inspection_jobs: Array<{ __typename?: 'inspection_jobs', id: any, property_id: any, organization_id: any, workspace_id: any, created_by_user_id: string, inspection_type: string, jurisdiction?: string | null, jurisdiction_id?: any | null, state: string, iris_score?: number | null, estimated_onsite_minutes?: number | null, requested_inspection_date?: any | null, property_context?: any | null, checklist_generated_at?: any | null, analysis_started_at?: any | null, analysis_completed_at?: any | null, error_message?: string | null, error_step?: string | null, report_json?: any | null, created_at?: any | null, updated_at?: any | null, property: { __typename?: 'properties', id: any, name: string, address?: string | null, building_type?: string | null, photo_link?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string } | null }, organization: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null }, user: { __typename?: 'users', id: string, first_name: string, last_name: string, email: string }, jurisdiction_record?: { __typename?: 'jurisdictions', id: any, name: string, short_name: string, state: string, county?: string | null, city?: string | null, ahj_type: string, primary_codes?: any | null, website_url?: string | null, notes?: string | null, active: boolean, created_at: any, updated_at: any } | null, inspection_checklist_items: Array<{ __typename?: 'inspection_checklist_items', id: any, sort_order: number, item_name: string, applicable_codes?: any | null, capture_instructions?: string | null, evaluation_criteria?: string | null, example_image_url?: string | null, status?: string | null, doctrine_item_key: string, required: boolean, doctrine_checklist_item_ref?: string | null, created_at: any, category: string, item_category?: { __typename?: 'inspection_checklist_item_category', name: string, label: string, short_label?: string | null, icon_source?: string | null, icon_name?: string | null } | null, evidence_findings: Array<{ __typename?: 'evidence_findings', id: any, job_id: any, submission_id: any, checklist_item_id: any, category: string, finding_status: string, description?: string | null, iris_analysis?: string | null, location?: string | null, confidence?: number | null, bbox_x?: number | null, bbox_y?: number | null, bbox_w?: number | null, bbox_h?: number | null, created_at?: any | null, updated_at?: any | null, inspector_feedbacks: Array<{ __typename?: 'inspector_feedback', id: any, job_id: any, finding_id?: any | null, gap_item_id?: any | null, user_id: string, accurate?: boolean | null, decision?: string | null, error_attribution?: string | null, comment?: string | null, created_at: any, updated_at: any }> }>, evidence_submissions: Array<{ __typename?: 'evidence_submissions', id: any, job_id: any, checklist_item_id: any, uploaded_by_user_id?: string | null, source_type: string, file_name: string, file_url: string, file_size_bytes?: any | null, mime_type: string, exif_gps_lat?: any | null, exif_gps_lon?: any | null, exif_timestamp?: any | null, review_status: string, created_at?: any | null, updated_at?: any | null }>, gap_analysis_items: Array<{ __typename?: 'gap_analysis_items', id: any, job_id: any, checklist_item_id: any, finding_id?: any | null, rule_id: string, status: string, severity: string, confidence?: number | null, reason: string, corrective_action?: string | null, verify_type?: string | null, requires_onsite_verification: boolean, priority_rank?: number | null, created_at: any, inspector_feedbacks: Array<{ __typename?: 'inspector_feedback', id: any, job_id: any, finding_id?: any | null, gap_item_id?: any | null, user_id: string, accurate?: boolean | null, decision?: string | null, error_attribution?: string | null, comment?: string | null, created_at: any, updated_at: any }>, citations: Array<{ __typename?: 'citations', id: any, gap_item_id: any, tier: string, source: string, section?: string | null, chunk_id?: string | null, source_url?: string | null, created_at?: any | null }> }> }>, inspection_job_state_logs: Array<{ __typename?: 'inspection_job_state_log', id: any, job_id: any, from_state?: string | null, to_state: string, metadata?: any | null, created_at: any }>, user_invitations: Array<{ __typename?: 'user_invitations', id: any, email: string, role?: string | null, status: string, message?: string | null, properties_ids?: Array<string> | null, organization_id?: any | null, sender_id?: string | null, handover_id?: any | null, sender?: { __typename?: 'users', id: string, first_name: string, last_name: string, role?: string | null, email: string, organization_id?: any | null } | null }> }> };


export const GetFilteredInspectionJobsDocument = gql`
    query getFilteredInspectionJobs($where: inspection_jobs_bool_exp) {
  inspection_jobs(where: $where, order_by: {property: {name: asc}}) {
    id
    property_id
    property {
      id
      name
      address
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
      }
      building_type
      photo_link
    }
    organization_id
    organization {
      id
      name
      type
      organizationImageURL
    }
    workspace_id
    created_by_user_id
    user {
      id
      first_name
      last_name
      email
    }
    inspection_type
    jurisdiction
    jurisdiction_id
    jurisdiction_record {
      id
      name
      short_name
      state
      county
      city
      ahj_type
      primary_codes
      website_url
      notes
      active
      created_at
      updated_at
    }
    state
    iris_score
    estimated_onsite_minutes
    requested_inspection_date
    property_context
    checklist_generated_at
    analysis_started_at
    analysis_completed_at
    error_message
    error_step
    report_json
    created_at
    updated_at
    inspection_checklist_items(order_by: [{sort_order: asc}, {category: asc}]) {
      id
      sort_order
      item_name
      applicable_codes
      capture_instructions
      evaluation_criteria
      example_image_url
      status
      doctrine_item_key
      required
      doctrine_checklist_item_ref
      created_at
      category
      item_category {
        name
        label
        short_label
        icon_source
        icon_name
      }
      evidence_findings {
        id
        job_id
        submission_id
        checklist_item_id
        category
        finding_status
        description
        iris_analysis
        location
        confidence
        bbox_x
        bbox_y
        bbox_w
        bbox_h
        created_at
        updated_at
        inspector_feedbacks {
          id
          job_id
          finding_id
          gap_item_id
          user_id
          accurate
          decision
          error_attribution
          comment
          created_at
          updated_at
        }
      }
      evidence_submissions {
        id
        job_id
        checklist_item_id
        uploaded_by_user_id
        source_type
        file_name
        file_url
        file_size_bytes
        mime_type
        exif_gps_lat
        exif_gps_lon
        exif_timestamp
        review_status
        created_at
        updated_at
      }
      gap_analysis_items {
        id
        job_id
        checklist_item_id
        finding_id
        rule_id
        status
        severity
        confidence
        reason
        corrective_action
        verify_type
        requires_onsite_verification
        priority_rank
        created_at
        inspector_feedbacks {
          id
          job_id
          finding_id
          gap_item_id
          user_id
          accurate
          decision
          error_attribution
          comment
          created_at
          updated_at
        }
        citations {
          id
          gap_item_id
          tier
          source
          section
          chunk_id
          source_url
          created_at
        }
      }
    }
    inspection_job_state_logs {
      id
      job_id
      from_state
      to_state
      metadata
      created_at
    }
    user_invitations {
      id
      email
      role
      status
      message
      properties_ids
      organization_id
      sender_id
      sender {
        id
        first_name
        last_name
        role
        email
        organization_id
      }
      handover_id
    }
  }
}
    `;

/**
 * __useGetFilteredInspectionJobsQuery__
 *
 * To run a query within a React component, call `useGetFilteredInspectionJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredInspectionJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredInspectionJobsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFilteredInspectionJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetFilteredInspectionJobsQuery, GetFilteredInspectionJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredInspectionJobsQuery, GetFilteredInspectionJobsQueryVariables>(GetFilteredInspectionJobsDocument, options);
      }
export function useGetFilteredInspectionJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredInspectionJobsQuery, GetFilteredInspectionJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredInspectionJobsQuery, GetFilteredInspectionJobsQueryVariables>(GetFilteredInspectionJobsDocument, options);
        }
export function useGetFilteredInspectionJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFilteredInspectionJobsQuery, GetFilteredInspectionJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFilteredInspectionJobsQuery, GetFilteredInspectionJobsQueryVariables>(GetFilteredInspectionJobsDocument, options);
        }
export type GetFilteredInspectionJobsQueryHookResult = ReturnType<typeof useGetFilteredInspectionJobsQuery>;
export type GetFilteredInspectionJobsLazyQueryHookResult = ReturnType<typeof useGetFilteredInspectionJobsLazyQuery>;
export type GetFilteredInspectionJobsSuspenseQueryHookResult = ReturnType<typeof useGetFilteredInspectionJobsSuspenseQuery>;
export type GetFilteredInspectionJobsQueryResult = Apollo.QueryResult<GetFilteredInspectionJobsQuery, GetFilteredInspectionJobsQueryVariables>;